<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toccn" id="copy_1"><span href="#/KingofStorms_copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toccn" id="prol_1"><a href="#/KingofStorms_prol_1">Prologue</a></p>
<p class="toccn" id="chap_1"><a href="#/KingofStorms_chap_1">Chapter 1</a></p>
<p class="toccn" id="chap_2"><a href="#/KingofStorms_chap_2">Chapter 2</a></p>
<p class="toccn" id="chap_3"><span href="#/KingofStorms_chap_3" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toccn" id="chap_4"><span href="#/KingofStorms_chap_4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toccn" id="chap_5"><span href="#/KingofStorms_chap_5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toccn" id="chap_6"><span href="#/KingofStorms_chap_6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toccn" id="chap_7"><span href="#/KingofStorms_chap_7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toccn" id="chap_8"><span href="#/KingofStorms_chap_8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toccn" id="chap_9"><span href="#/KingofStorms_chap_9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toccn" id="chap_10"><span href="#/KingofStorms_chap_10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toccn" id="chap_11"><span href="#/KingofStorms_chap_11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toccn" id="chap_12"><span href="#/KingofStorms_chap_12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toccn" id="chap_13"><span href="#/KingofStorms_chap_13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toccn" id="chap_14"><span href="#/KingofStorms_chap_14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toccn" id="chap_15"><span href="#/KingofStorms_chap_15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toccn" id="chap_16"><span href="#/KingofStorms_chap_16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toccn" id="chap_17"><span href="#/KingofStorms_chap_17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toccn" id="chap_18"><span href="#/KingofStorms_chap_18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toccn" id="chap_19"><span href="#/KingofStorms_chap_19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toccn" id="chap_20"><span href="#/KingofStorms_chap_20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toccn" id="chap_21"><span href="#/KingofStorms_chap_21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="toccn" id="epil_1"><span href="#/KingofStorms_epil_1" title="Link target outside of Sample">Epilogue</span></p>
<p class="toccn" id="auth_bio_1"><span href="#/KingofStorms_auth_bio_1" title="Link target outside of Sample">About the Author</span></p>
<p class="toccn" id="teas_1"><span href="#/KingofStorms_teas_1" title="Link target outside of Sample">Border Wedding</span></p>
<p class="toccn" id="appe_1"><span href="#/KingofStorms_appe_1" title="Link target outside of Sample">Chapter 1</span></p>
<p class="toccn" id="appe_2"><span href="#/KingofStorms_appe_2" title="Link target outside of Sample">The Dish</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KingofStorms_toc.vue?23359515